import i18n from '@/i18n/i18n'
import ProductMarketPriceService from '@/services/admin/ProductMarketPriceService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = ['product_id']
export const allowedIncludes = []
export const allowedAppends = []
export const allowedSorts = []

export const namespaced = true

export const state = {
  productMarketPrices: [],
  meta: {},
  productMarketPrice: null
}

export const mutations = {
  SET_PRODUCT_MARKET_PRICES(state, productMarketPrice) {
    state.productMarketPrices = productMarketPrice.data
    state.meta = productMarketPrice.meta
  },
  SET_PRODUCT_MARKET_PRICE(state, productMarketPrice) {
    state.productMarketPrice = productMarketPrice.data
  }
}

export const actions = {
  getAllProductMarketPrice({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      ProductMarketPriceService.getAllProductMarketPrice(newQuery)
        .then(response => {
          commit('SET_PRODUCT_MARKET_PRICES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.product_market_price.get_all_product_market_price_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getProductMarketPrice({ commit, dispatch }, productMarketPriceId) {
    return new Promise((resolve, reject) => {
      ProductMarketPriceService.getProductMarketPrice(productMarketPriceId)
        .then(response => {
          if (response.data.length === 0) {
            const notification = {
              type: 'danger',
              message: t('store.admin.product_market_price.get_product_market_price_error') + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
          } else {
            commit('SET_PRODUCT_MARKET_PRICE', response)
            resolve(response.data)
          }
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.product_market_price.get_product_market_price_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  storeMarketPrice({ commit, dispatch }, productMarketPrice) {
    return new Promise((resolve, reject) => {
      ProductMarketPriceService.storeMarketPrice(productMarketPrice)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.product_market_price.update_market_price_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.product_market_price.update_market_price_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
